export default __webpack_public_path__ + "static/media/campur.69d51e73.png";